<template>
  <div v-if="hasBindData.isExistShop">
    <el-card class="prodinfo--card">
      <z-search :configs="configs" @do-query="query" ref="search" v-model="searchData">
        <template #category_ids>
          <el-cascader
            v-model.trim="searchData['category_ids']"
            dictKey="category_ids"
            :placeholder="$t('stores::products-info::select_category')"
            clearable
            filterable
            :options="categoryList"
            :props="{ label: 'name', value: 'id', children: 'children', checkStrictly: true }"
          >
            <template #mainEmpty>
              <div class="empty-cate">
                <p>暂无类目</p>
                <el-button type="text" @click="onUpload">快速导入类目</el-button>
              </div>
            </template>
          </el-cascader>
        </template>
      </z-search>
    </el-card>
    <el-card style="margin-top: 10px">
      <div class="prodinfo--list__btnWrap" style="justify-content: space-between">
        <div>
          <!-- <el-button type="primary" @click="toAdd" icon="el-icon-plus" v-auth="'stores::products-info::add'">
            {{ $t('stores::products-info::add') }}
          </el-button>
          <el-dropdown class="btn-item">
            <el-button :disabled="tableSelections.length === 0">
              {{ $t('stores::products-info::batch_operate') }}
              <i class="el-icon-caret-bottom"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-auth="'stores::products-info::tag'">
                <span @click="batchSetTag = true">{{ $t('stores::products-info::batch_tags') }}</span>
              </el-dropdown-item>
              <el-dropdown-item v-auth="'stores::products-info::set_supplier'">
                <span @click="$refs.setSupplier.showDialog()">{{ $t('stores::products-info::edit_supplier') }}</span>
              </el-dropdown-item>
              <el-dropdown-item v-auth="'stores::products-info::set_safe_sku'">
                <span @click="$refs.setSku.showDialog()">{{ $t('stores::products-info::edit_safe_sku') }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </div>
        <div style="text-align: right">
          <el-button @click="importLog" class="btn-item" v-auth="'stores::products-info::uploadLog'">
            {{ $t('stores::products-info::import_log') }}
          </el-button>

          <el-button @click="onUpload" class="btn-item"   v-auth="'stores::products-info::upload'">{{ $t('stores::products-info::import') }}</el-button>

          <el-button
            :loading="exportLoading"
            @click="exportGoods"
            class="btn-item"
            v-auth="'stores::products-info::export'"
          >
            {{ $t('stores::products-info::export') }}
          </el-button>
        </div>
      </div>
      <div class="prodinfo--list__tips" v-show="tableSelections.length">
        <span>{{ $t('stores::products-info::select_num', { x: tableSelections.length }) }}</span>
        <span>{{ $t('stores::products-info::use_stock') }}：{{ totalAvailableInventory || 0 }}</span>
        <span>{{ $t('stores::products-info::goods_stock') }}：{{ totalSpuInventory || 0 }}</span>
      </div>
      <z-table
        :cell-class-name="cellClass"
        :columns="tableColumns"
        :data="tableData"
        :max-height="520"
        :row-class-name="tableRowClassName"
        :pagination.sync="pagination"
        :tree-props="{ children: 'skus' }"
        @page-change="handlePageChange"
        @selection-change="handleSelectTable"
        class="prodinfo--table"
        row-key="id"
        v-loading="loading"
      >
        <template #title="{ row }">
          <div class="prodinfo--table__imgTd" style="line-height: 0">
            <el-popover placement="top-start" trigger="hover" style="margin-right: 24px">
              <ZImg :src="row.imageUrl" style="width: 250px; height: 250px"></ZImg>
              <ZImg :src="row.imageUrl" class="images" slot="reference"></ZImg>
            </el-popover>
            <div>
              <div class="prodinfo--table__title" slot="tooptip">{{ row.title }}</div>
              <div v-if="row.skuId" class="prodinfo--table__spu">SKU: {{ row.skuId }}</div>
              <div v-else class="prodinfo--table__spu">
                SPU: {{ row.spuId }}
                <!-- {{ row.categoryNames !== '' && row.categoryNames !== null ? ' | ' + row.categoryNames : '' }} -->
              </div>
              <div class="tag-wrap" v-if="row.tags !== null && row.tags !== undefined && row.tags.length !== 0">
                <el-tag
                  class="tag-cell-item common-tag"
                  size="mini"
                  style="margin-right: 4px"
                  closable
                  color="#fff"
                  @close.stop="releaseTag(item, row)"
                  v-for="(item, index) in row.tags.filter((value, valueIndex) => {
                    return valueIndex < 3
                  })"
                  :key="index"
                  :title="item.name"
                >
                  {{ item.name }}
                </el-tag>
                <el-dropdown v-if="row.tags.length > 3">
                  <el-tag class="common-tag expand-tag" size="mini" color="#fff" style="margin-right: 2px">...</el-tag>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in row.tags" :key="index">
                      <el-tag class="product--table__tag" size="medium" closable @close.stop="releaseTag(item, row)">
                        {{ item.name }}
                      </el-tag>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="prodinfo--table__spu">
                {{ row.optionValueNames }}
              </div>
            </div>
          </div>
        </template>
        <template #purchasePrice="{ row }">
          <span v-if="row.purchasePrice">{{ priceFormat(row, 'purchasePrice') }}</span>
          <span v-else>--</span>
        </template>
        <template #compareAtPrice="{ row }">
          <span v-if="row.compareAtPrice">{{ priceFormat(row, 'compareAtPrice') }}</span>
          <span style="color: red" v-else>{{ editText.not_pricing }}</span>
        </template>
        <template #salePrice="{ row }">
          <span v-if="row.salePrice">{{ priceFormat(row, 'salePrice') }}</span>
          <span style="color: red" v-else>{{ editText.not_pricing }}</span>
        </template>
        <template #store="{ row }">
          <div>{{ editText.use_stock }}: {{ $dataCheck(row.availableInventory, '--') }}</div>
          <div>
            {{ editText.goods_stock }}:
            <span :style="`color:${compareCount(row.spuId ? row.spuInventory : row.skuInventory, row.safeInventory)}`">
              {{ $dataCheck(row.spuId ? row.spuInventory : row.skuInventory, '--') }}
            </span>
          </div>
          <div>{{ editText.safe_stock }}: {{ $dataCheck(row.safeInventory, '--') }}</div>
        </template>
        <template #status="{ row }">
          <!-- <el-select
            :value="row.spuId ? row.spuStatus : row.skuStatus"
            @change="handleUpDown(row)"
            style="width: 100px"
            v-if="row.spuId"
          >
            <el-option :label="editText.put_on" :value="1"></el-option>
            <el-option :label="editText.put_down" :value="0"></el-option>
          </el-select> -->
          <!-- <el-switch
            v-if="row.spuId"
            :value="row.spuId ? !!row.spuStatus : !!row.skuStatus"
            @change="handleUpDown(row)"
          ></el-switch> -->
          <span>
            {{
              (row.spuId ? !!row.spuStatus : !!row.skuStatus)
                ? $t('stores::store::goods::put_on')
                : $t('stores::store::goods::put_off')
            }}
          </span>
        </template>
        <template #opt="{ row }">
          <div v-if="row.spuId">
            <!-- <el-button @click.stop="handleToEdit(row)" type="text" v-auth="'stores::products-info::edit'">
              {{ editText.edit }}
            </el-button> -->
            <el-button @click.stop="handleToDetail(row)" type="text" v-auth="'stores::products-info::detail'">
              {{ editText.detail }}
            </el-button>
            <!-- <el-dropdown>
              <el-button type="text" style="margin-left:24px">
                {{ editText.more }}
                <i class="el-icon-arrow-down"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.stop.native="handleSetPrice(row)">
                  <el-button type="text" v-auth="'stores::products-info::edit'">
                    {{ editText.pricing }}
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item @click.native="handleCopy(row)">
                  <el-button type="text" v-auth="'stores::products-info::copy'">{{ editText.copy }}</el-button>
                </el-dropdown-item>
                <el-dropdown-item @click.stop.native="handleSellManage(row)">
                  <el-button :disabled="!row.spuStatus" type="text" v-auth="'stores::products-info::sale'">
                    {{ editText.sale_manager }}
                  </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
          </div>
        </template>
      </z-table>
    </el-card>
    <!-- <el-dialog
      :close-on-click-modal="false"
      :title="$t('stores::products-info::price')"
      :visible.sync="setPriceDialog"
      width="700px"
    >
      <el-form :model="currentRow" ref="dynamicValidateForm" class="product--setPrice__form">
        <el-table :data="currentRow.skus" v-loading="priceListLoading" :max-height="500">
          <el-table-column label="SKU">
            <template slot-scope="{ row }">
              <div class="prodinfo--table__imgTd">
                <div>
                  <div>{{ row.skuId }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="purchasePrice" min-width="120">
            <template slot="header" slot-scope="scope">
              <el-input
                v-model.trim="priceDialogHeader.purchasePrice"
                @change="val => handlePriceChange(scope, val)"
                :placeholder="editText.cost_price_shipping"
              ></el-input>
            </template>
            <template slot-scope="{ row, $index }">
              <el-form-item
                :key="$index"
                :prop="`skus.${$index}.purchasePrice`"
                :rules="[
                  {
                    required: true,
                    message: $t('system::common::input_holder'),
                    trigger: 'blur',
                    validator: checkInputSales
                  }
                ]"
                label-width="0"
              >
                <el-input
                  :class="row.purchasePrice == 0 ? 'holder__color' : ''"
                  :placeholder="$t('system::common::input_holder')"
                  v-model="row.purchasePrice"
                >
                  <template slot="prepend">￥</template>
                </el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="compareAtPrice" min-width="100">
            <template slot="header" slot-scope="scope">
              <el-input
                v-model.trim="priceDialogHeader.compareAtPrice"
                @change="val => handlePriceChange(scope, val)"
                :placeholder="editText.origin_price_shipping"
              />
            </template>
            <template slot-scope="{ row, $index }">
              <el-form-item
                :key="$index"
                :prop="`skus.${$index}.compareAtPrice`"
                :rules="[
                  {
                    required: true,
                    message: $t('system::common::input_holder'),
                    trigger: 'blur',
                    validator: checkInputSales
                  }
                ]"
                label-width="0"
              >
                <el-input
                  :class="row.compareAtPrice == 0 ? 'holder__color' : ''"
                  :placeholder="$t('system::common::input_holder')"
                  v-model="row.compareAtPrice"
                >
                  <template slot="prepend">$</template>
                </el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="salePrice" min-width="100">
            <template slot="header" slot-scope="scope">
              <el-input
                :placeholder="editText.sale_price_shipping"
                @change="val => handlePriceChange(scope, val)"
                v-model.trim="priceDialogHeader.salePrice"
              />
            </template>
            <template slot-scope="{ row, $index }">
              <el-form-item
                :key="$index"
                :prop="`skus.${$index}.salePrice`"
                :rules="[
                  {
                    required: true,
                    message: $t('system::common::input_holder'),
                    trigger: 'blur',
                    validator: checkInputSales
                  }
                ]"
                label-width="0"
              >
                <el-input
                  :class="row.salePrice == 0 ? 'holder__color' : ''"
                  :placeholder="$t('system::common::input_holder')"
                  v-model="row.salePrice"
                >
                  <template slot="prepend">$</template>
                </el-input>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="setPriceDialog = false" size="small">{{ $t('system::common::btn::cancel') }}</el-button>
        <el-button :loading="savePriceLoading" @click="setPriceConfirm" type="primary" size="small">
          {{ $t('system::common::btn::save') }}
        </el-button>
      </div>
    </el-dialog> -->
    <!-- <el-dialog
      :close-on-click-modal="false"
      :title="$t('stores::products-info::batch_tags')"
      :visible.sync="batchSetTag"
      width="500px"
    >
      <el-form>
        <el-form-item label="SPU">{{ tableSelections.map(item => item.spuId).join(',') }}</el-form-item>
        <el-form-item :label="$t('stores::products-info::goods_tag')">
          <el-select multiple v-model="shopTag">
            <el-option :key="item.id" :label="item.tagName" :value="item.id" v-for="item in tagOptions"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="batchSetTag = false" size="small">{{ $t('system::common::btn::cancel') }}</el-button>
        <el-button @click="batchTagConfirm" type="primary" size="small">
          {{ $t('system::common::btn::save') }}
        </el-button>
      </div>
    </el-dialog> -->
    <!-- <el-dialog
      :close-on-click-modal="false"
      :title="$t('stores::products-info::sale_manager')"
      :visible.sync="sellManagement"
      width="720px"
    >
      <el-card body-style="padding: 0 16px 16px" v-loading="sellManagementLoading">
        <div slot="header" style="font-size: 16px; font-weight: bold">
          {{ $t('stores::products-info::goods_info') }}
        </div>
        <el-form inline>
          <el-form-item label="SPU:" style="min-width: 200px; margin-bottom: 0">
            {{ currentRow.spuId }}
          </el-form-item>
          <el-form-item :label="`${$t('stores::products-info::name')}:`" style="min-width: 200px; margin-bottom: 0">
            {{ currentRow.title }}
          </el-form-item>
          <el-form-item :label="`${$t('stores::products-info::category')}:`" style="min-width: 200px; margin-bottom: 0">
            {{ currentRow.categoryNames }}
          </el-form-item>
          <el-form-item :label="`${$t('system::responsible::供应商')}:`" style="min-width: 200px; margin-bottom: 0">
            {{ currentRow.supplier }}
          </el-form-item>
        </el-form>
      </el-card>
      <el-button
        :disabled="
          dialogTableSelection.length === 0 ||
            dialogTableSelection.some(item => item.publishStatus === 1 || item.publishStatus === 2)
        "
        :loading="publishLoading"
        @click="batchPublish"
        style="margin-bottom: 10px"
        type="primary"
      >
        {{ $t('stores::products-info::batch_had_release') }}
      </el-button>

      <el-table :data="sellTableData" @selection-change="dialogTableSelectChange" max-height="500px">
        <el-table-column type="selection"></el-table-column>
        <el-table-column :label="$t('stores::products-info::store')" prop="shopName"></el-table-column>
        <el-table-column :label="$t('stores::products-info::store_spu')" prop="shopSpuId"></el-table-column>
        <el-table-column :label="$t('stores::products-info::status')" prop="status">
          <template slot-scope="{ row }">
            <div>
              {{ $t('stores::products-info::sale_status') }}:
              {{ row.saleStatus ? $t('stores::products-info::is_sale') : $t('stores::products-info::stop_sale') }}
            </div>
            <div>
              {{ $t('stores::products-info::release_status') }}: {{ getPublishStatus(row.publishStatus) }}
              <i class="el-icon-warning-outline" style="color: red" v-if="row.publishStatus === 3"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('stores::products-info::operate')">
          <template slot-scope="{ row }">
            <el-button
              :disabled="row.publishStatus === 1 || row.publishStatus === 2"
              :loading="row.saleLoading === 'pub'"
              @click="dialogPublish(row, 'pub')"
              type="text"
            >
              {{ $t('stores::products-info::release') }}
            </el-button>
            <el-button
              :disabled="row.publishStatus === 1"
              :loading="row.saleLoading === 'stop'"
              @click="dialogStopSales(row, 'stop')"
              type="text"
              v-if="row.saleStatus"
            >
              {{ $t('stores::products-info::stop_sale') }}
            </el-button>
            <el-button
              :disabled="row.publishStatus === 1"
              :loading="row.saleLoading === 'start'"
              @click="dialogSales(row, 'start')"
              type="text"
              v-else
            >
              {{ $t('stores::products-info::is_sale') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog> -->
    <!-- <saleDialog :handleProduct="handleProduct" @closeDialog="closeDialog" v-model="isShowSaleDialog"></saleDialog> -->
    <!-- <el-drawer :show-close="false" :visible.sync="isShowDetailDrawer" size="40%">
      <div class="drawer-title" slot="title">{{ $t('stores::products-info::goods_detail') }}</div>
      <el-scrollbar>
        <detailDrawer :id="productDetail.spuId" :isShowDetailDrawer="isShowDetailDrawer"></detailDrawer>
      </el-scrollbar>
    </el-drawer> -->
    <importLogModal v-model="importLogVisable"></importLogModal>
    <ImportDialog
      @save="onSaveUpload"
      v-model="importFileVisable"
      ref="importDialog"
      @export="exportGoods"
    ></ImportDialog>
    <!-- <importFileModal @save="onSaveUpload" v-model="importFileVisable"></importFileModal> -->
    <!-- <batch-set-sku ref="setSku" :selection="tableSelections" @success="handlePageChange"></batch-set-sku>
    <batch-set-supplier
      ref="setSupplier"
      :selection="tableSelections"
      :supplierList="supplierList"
      @success="handlePageChange"
    ></batch-set-supplier> -->
  </div>
  <div v-else>
    <emptyCard
      :data="{
        title: $t('stores::products-info::empty_goods'),
        img: require('@/assets/images/emptyDefault/commodity@2x.png'),
        desc: $t('stores::products-info::empty_goods_tips'),
        buttons: [
          { click: onBindShop, text: $t('stores::products-info::empty_bind_store'), auth: 'stores::store::add' },
        ],
      }"
    ></emptyCard>
  </div>
</template>

<script>
import { searchConfig, tableColumns, tagConfig } from './configData/index'
import detailDrawer from '../detail/drawer'
import * as Api from '@/server/product'
import ZTable from '@/components/common/table/main'
import { downloadBlobFile } from '@/utils'
import saleDialog from '../components/saleDialog'
import importLogModal from '../components/import-log-modal.vue'
import importFileModal from '../components/import-file-modal.vue'
import BatchSetSku from '../../components/BatchSetSku'
import BatchSetSupplier from '../../components/BatchSetSupplier'
import ImportDialog from '../components/importDialog'
import moment from 'moment'
export default {
  name: 'index',
  components: {
    ZTable,
    detailDrawer,
    saleDialog,
    importLogModal,
    importFileModal,
    BatchSetSku,
    BatchSetSupplier,
    ImportDialog,
  },
  data() {
    return {
      editText: {
        not_pricing: this.$t('stores::products-info::not_pricing'),
        use_stock: this.$t('stores::products-info::use_stock'),
        goods_stock: this.$t('stores::products-info::goods_stock'),
        safe_stock: this.$t('stores::products-info::safe_stock'),
        put_on: this.$t('stores::products-info::put_on'),
        put_down: this.$t('stores::products-info::put_down'),
        edit: this.$t('stores::products-info::edit'),
        detail: this.$t('stores::products-info::detail'),
        more: this.$t('stores::products-info::more'),
        pricing: this.$t('stores::products-info::pricing'),
        copy: this.$t('stores::products-info::copy'),
        sale_manager: this.$t('stores::products-info::sale_manager'),
        origin_price_shipping: this.$t('stores::products-info::origin_price_shipping'),
        sale_price_shipping: this.$t('stores::products-info::sale_price_shipping'),
        cost_price_shipping: `${$t('stores::products-info::supply_cost')} | ${$t(
          'stores::products-info::include_deliver_fee'
        )}`,
      },
      priceDialogHeader: {
        compareAtPrice: '',
        salePrice: '',
        purchasePrice: '',
      },
      sellManagementLoading: false,
      savePriceLoading: false,
      configs: searchConfig(tagConfig.PUBLISHED),
      priceListLoading: false,
      saleLoading: false,
      tagConfig,
      btnLoading: false,
      tabMode: tagConfig,
      searchData: {
        filterObj: 'spuId',
        shop_id: '',
      },
      tableColumns,
      uploading: false,
      exportLoading: false,
      totalAvailableInventory: 0,
      totalSpuInventory: 0,
      tableData: [],
      setPriceDialogId: null,
      setPriceDialog: false,
      batchSetTag: false,
      tableSelections: [],
      sellManagement: false,
      currentRow: {
        skus: [],
      },
      sellTableData: [],
      dialogTableSelection: [],
      pagination: {
        pageNum: 1, // 页码
        pageSize: 10, // 每页大小
        total: 0,
      },
      file: null,
      loading: false,
      importFileVisable: false,
      importLogVisable: false,
      shopList: [],
      tagOptions: [],
      shopTag: [],
      publishLoading: false,
      isShowDetailDrawer: false,
      productDetail: {},
      isShowSaleDialog: false,
      handleProduct: {},
      supplierList: [],
      currentHover: '',
      categoryList: [],
    }
  },
  watch: {},
  mounted() {
    this.handlePageChange()
    this.getSearchConfig()
  },
  activated() {
    // this.handlePageChange()
  },
  methods: {
    keepAliveRefresh() {
      this.pagination.pageNum = 1
      this.handlePageChange()
    },
    onUpload() {
      this.importFileVisable = true
    },
    onSaveUpload() {
      this.pagination.pageNum = 1
      this.handlePageChange()
      this.getSearchConfig()
    },
    importLog() {
      this.importLogVisable = true
      // this.$router.push('/stores/task-center')
    },

    toAdd() {
      this.$store.dispatch('buried', { event: 'StoreManagementClick', buttonName: '新增商品' })
      this.$router.push({ path: '/products-info/add/add' })
    },
    onBindShop() {
      this.$store.commit('setShopVisiable', { visiable: true })
    },
    onGoodAdd() {
      this.$store.dispatch('buried', { event: 'StoreManagementClick', buttonName: '新增商品' })
      this.$router.push({ path: '/products-info/add/add' })
    },
    // 隐藏sku选择框
    cellClass(row) {
      if (row.columnIndex === 0 && !row.row.spuId) {
        return 'table-selection'
      }
    },
    async exportGoods() {
      this.exportLoading = true
      this.$refs.importDialog.exportLoading = true
      let params = this.$refs.search.getSearchParams()
      delete params.filterObj
      delete params.target

      const res = await Api.exportProducts({
        ...params,
      })
      this.exportLoading = false
      this.$refs.importDialog.exportLoading = false
      if (res.code === this.$code) {
        downloadBlobFile(
          res.response.data,
          {
            type: 'application/csv;charset=UTF-8',
          },
          `products_${moment().format('YYYYMMDD')}.csv`
        )
      }
    },
    async getSearchConfig(type) {
      this.configs = searchConfig(type, [], [], [], [])
      let shopList = []
      let tagList = []
      let categoryList = []
      let supplierList = []
      const params = { page_size: 100, page_num: 1 }
      const [res1, res2, res3, res4] = await Promise.all([
        Api.getShopList(), // 查询店铺
        Api.getTagList(params), // 查询标签
        Api.getProdCategories(params), // 查询类目
        Api.getSupplierList({ ...params, status: 1 }), // 查询供应商
      ])
      shopList = res1.data.data.map(item => {
        return {
          label: item.shopName,
          value: item.shopId,
        }
      })
      this.shopList = res1.data.data
      tagList = res2.data.data.items.map(item => {
        return {
          label: item.tagName,
          value: item.tagName,
        }
      })
      this.tagOptions = res2.data.data.items
      supplierList = res4.data.data.items.map(item => {
        return {
          label: item.name,
          value: item.id,
        }
      })
      this.supplierList = supplierList
      const fn = arr => {
        return arr.map(item => {
          if (item.childrens && item.childrens.length) {
            item.children = fn(item.childrens)
          }
          return item
        })
      }
      categoryList = fn(res3.data.data.items || [])
      this.categoryList = categoryList
      this.configs = searchConfig(type, shopList, tagList, categoryList, supplierList)
    },
    handlePageChange() {
      this.$nextTick(() => {
        const params = this.$refs.search && this.$refs.search.getSearchParams()
        this.getTableData(params)
      })
    },
    tableRowClassName({ row }) {
      if (row.skuId) {
        return 'customer--table__subRow'
      }
    },
    query(data) {
      this.pagination.pageNum = 1
      this.getTableData(data)
    },
    async getTableData(d) {
      d && delete d.filterObj
      d && delete d.target
      const params = {
        ...this.pagination,
        ...d,
      }
      delete params.total
      this.loading = true
      try {
        const { data } = await Api.getProductInfoList(params)
        this.loading = false
        if (data.code === this.$code) {
          this.tableData = data.data.items
          this.pagination.total = data.data.totalCount
        }
      } catch (e) {
        this.loading = false
      }
    },
    handleSelectTable(selection) {
      this.tableSelections = selection
      this.totalAvailableInventory = 0
      this.totalSpuInventory = 0
      if (selection.length !== 0) {
        selection.forEach(item => {
          this.totalAvailableInventory += item.availableInventory
          this.totalSpuInventory += item.spuInventory
        })
      } else {
        this.totalAvailableInventory = 0
        this.totalSpuInventory = 0
      }
    },
    // 发布
    handlePublish(row) {
      this.handleMessageBox(
        row,
        this.$t('stores::products-info::dialog_release_tips'),
        this.$t('stores::products-info::dialog_release_title')
      ).then(() => {
        this.btnLoading = true
        Api.publishProd({
          publish_vos: [
            {
              shop_id: this.searchData.shop_id,
              spu_id: row.spuId,
            },
          ],
        })
          .then(res => {
            this.btnLoading = false
            if (res.data.code === this.$code) {
              this.$message.success(this.$t('system::tip::control_success'))
              this.handlePageChange()
            }
          })
          .catch(() => {
            this.btnLoading = false
          })
      })
    },
    // 上下架
    handleUpDown(val) {
      let param = {}
      const h = this.$createElement
      if (val.spuStatus) {
        // 下架
        this.handleMessageBox(
          val,
          this.$t('stores::products-info::dialog_put_down_tips'),
          this.$t('stores::products-info::dialog_put_down_title')
        ).then(() => {
          if (val.spuId) {
            Api.spuUpDown({
              spuId: val.spuId,
              spuStatus: 0,
            }).then(res => {
              if (res.data.code === this.$code) {
                if (res.data.data) {
                  this.$message({
                    type: 'success',
                    message: h('p', null, [
                      h('span', null, this.$t('stores::products-info::message_had_down')),
                      h('span', { style: 'color: #0560FD' }, res.data.data.successCount),
                      h('span', null, `${$t('stores::products-info::message_goods_text')}，`),
                      h('span', null, this.$t('stores::products-info::message_down_fail')),
                      h('span', { style: 'color: #ff4300' }, res.data.data.failCount),
                      h('span', null, this.$t('stores::products-info::message_goods_text')),
                    ]),
                  })
                }

                this.handlePageChange()
              }
            })
          } else {
            Api.skuUpDown({
              skuId: val.skuId,
              skuStatus: 0,
            }).then(res => {
              if (res.data.code === this.$code) {
                if (res.data.data) {
                  this.$message({
                    type: 'success',
                    message: h('p', null, [
                      h('span', null, $t('stores::products-info::message_had_on')),
                      h('span', { style: 'color: #0560FD' }, res.data.data.successCount),
                      h('span', null, `${$t('stores::products-info::message_goods_text')}，`),
                      h('span', null, $t('stores::products-info::message_on_fail')),
                      h('span', { style: 'color: #ff4300' }, res.data.data.failCount),
                      h('span', null, this.$t('stores::products-info::message_goods_text')),
                    ]),
                  })
                }
                this.handlePageChange()
              }
            })
          }
        })
      } else {
        // 上架
        this.handleMessageBox(
          val,
          this.$t('stores::products-info::dialog_put_on_tips'),
          this.$t('stores::products-info::dialog_put_on_title')
        ).then(() => {
          if (val.spuId) {
            Api.spuUpDown({
              spuId: val.spuId,
              spuStatus: 1,
            }).then(res => {
              if (res.data.code === this.$code) {
                this.$message.success(this.$t('system::tip::control_success'))
                this.handlePageChange()
              }
            })
          } else {
            Api.skuUpDown({
              skuId: val.skuId,
              skuStatus: 1,
            }).then(res => {
              if (res.data.code === this.$code) {
                this.$message.success(this.$t('system::tip::control_success'))
                this.handlePageChange()
              }
            })
          }
        })
      }
    },
    // 复制
    handleCopy(row) {
      this.handleMessageBox(
        row,
        this.$t('stores::products-info::dialog_copy_tips', { title: row.title }),
        this.$t('stores::products-info::dialog_copy_title')
      ).then(() => {
        this.$router.push({
          path: `/products-info/add/${row.spuId}+copy`,
        })
      })
    },
    // 售卖管理
    handleSellManage(row) {
      this.isShowSaleDialog = true
      this.handleProduct = row
      // this.sellManagement = true
      // this.sellManagementLoading = true
      // Api.getSalesList(row.spuId).then(res => {
      //   if (res.data.code === this.$code) {
      //     this.sellTableData = res.data.data.map(item => {
      //       return {
      //         ...item,
      //         saleLoading: false
      //       }
      //     })
      //     this.currentRow = row
      //     // this.sellManagement = true
      //   }
      //   this.sellManagementLoading = false
      // })
    },
    compareCount(target1, target2) {
      if (target1 > target2) {
        return '#67C23A'
      } else if (target1 < target2) {
        return '#ff3c2a'
      } else {
        return 'inheirt'
      }
    },
    //  定价参数统改
    handlePriceChange(data, val) {
      const regEx = new RegExp(/^\d+(\.\d+)?$/)
      if (val !== '') {
        if (regEx.test(val)) {
          this.currentRow.skus = this.currentRow.skus.map(item => {
            item[data.column.property] = val
            return {
              ...item,
            }
          })
        } else {
          this.$message.error($t('system::common::input_number'))
          this.priceDialogHeader[data.column.property] = ''
        }
      }
    },
    checkInputSales(rule, value, callback) {
      const regEx = new RegExp(/^\d+(\.\d+)?$/)
      if (value === '') {
        callback(new Error())
      } else if (!regEx.test(value)) {
        this.$message.error($t('system::common::input_number'))
        callback(new Error())
      } else {
        callback()
      }
    },
    // 获取定价列表
    async getPriceList(id) {
      this.priceListLoading = true
      const { data } = await Api.getPriceList(id)
      this.priceListLoading = false
      if (data.code === this.$code) {
        this.currentRow.skus = data.data
      }
    },
    // 定价
    async handleSetPrice(row) {
      this.setPriceDialog = true
      this.setPriceDialogId = row.spuId
      await this.getPriceList(row.spuId)
    },
    // 售卖管理  批量发布
    batchPublish() {
      const list = this.dialogTableSelection.map(item => {
        return {
          spu_id: item.spuId,
          shop_id: item.shopId,
        }
      })
      this.publishLoading = true
      Api.publishProd({ publish_vos: list })
        .then(res => {
          if (res.data.code === this.$code) {
            this.$message.success(this.$t('system::tip::control_success'))
            this.handleSellManage(this.currentRow.spuId)
          }
          this.publishLoading = false
        })
        .catch(() => {
          this.publishLoading = true
        })
    },
    // 售卖管理  发布
    dialogPublish(row, type) {
      this.handleMessageBox(
        row,
        this.$t('stores::products-info::dialog_release_again_tips', { name: row.shopName }),
        this.$t('stores::products-info::dialog_release_again_title')
      ).then(() => {
        row.saleLoading = type
        Api.publishProd({
          publish_vos: [
            {
              spu_id: row.spuId,
              shop_id: row.shopId,
            },
          ],
        })
          .then(res => {
            row.saleLoading = false
            if (res.data.code === this.$code) {
              this.$message.success(this.$t('system::tip::control_success'))
              this.handleSellManage({ ...this.currentRow })
            }
          })
          .catch(() => {
            row.saleLoading = false
          })
      })
    },
    // 售卖管理  停售
    dialogStopSales(row, type) {
      const h = this.$createElement
      this.handleMessageBox(
        row,
        this.$t('stores::products-info::dialog_stop_sale_tips', { name: row.shopName }),
        this.$t('stores::products-info::dialog_stop_sale_title')
      ).then(() => {
        row.saleLoading = type
        Api.spuSaleStatus({
          spu_id: row.spuId,
          shop_id: row.shopId,
          publish_status: 0,
        })
          .then(res => {
            row.saleLoading = false
            if (res.data.code === this.$code) {
              if (res.data.data) {
                this.$message({
                  type: 'success',
                  message: h('p', null, [
                    h('span', null, this.$t('stores::products-info::message_stop_sale')),
                    h('span', { style: 'color: #0560FD' }, res.data.data.successCount),
                    h('span', null, `${$t('stores::products-info::message_store_text')}，`),
                    h('span', null, this.$t('stores::products-info::message_stop_fail')),
                    h('span', { style: 'color: #ff4300' }, res.data.data.failCount),
                    h('span', null, this.$t('stores::products-info::message_store_text')),
                  ]),
                })
              }
              this.handleSellManage({ ...this.currentRow })
            }
          })
          .catch(() => {
            row.saleLoading = false
          })
      })
    },
    // 处理表格价格显示
    priceFormat(row, priceField) {
      // spu
      if (row.skus && row.skus.length > 0) {
        const prices = row.skus.filter(p => p[priceField]).map(p => p[priceField])
        if (prices.length > 0) {
          const minPrice = Math.min.apply(Math, prices).toFixed(2)
          const maxPrice = Math.max.apply(Math, prices).toFixed(2)
          if (minPrice === maxPrice) {
            return minPrice
          } else {
            return `${minPrice}-${maxPrice}`
          }
        }
      }
      // sku
      return row[priceField].toFixed(2)
    },
    // 处理售卖状态
    getPublishStatus(status) {
      switch (status) {
        case 0:
          return this.$t('stores::store::goods::release_wait')
        case 1:
          return this.$t('stores::store::goods::release_ing')
        case 2:
          return this.$t('stores::store::goods::release_had')
        case 3:
          return this.$t('stores::store::goods::release_fail')
      }
    },
    // 售卖管理  开售
    dialogSales(row, type) {
      const h = this.$createElement
      this.handleMessageBox(
        row,
        this.$t('stores::products-info::dialog_start_sale_tips', { name: row.shopName }),
        this.$t('stores::products-info::dialog_start_sale_title')
      ).then(() => {
        row.saleLoading = type
        Api.spuSaleStatus({
          spu_id: row.spuId,
          shop_id: row.shopId,
          publish_status: 1,
        })
          .then(res => {
            row.saleLoading = false
            if (res.data.code === this.$code) {
              if (res.data.data) {
                this.$message({
                  type: 'success',
                  message: h('p', null, [
                    h('span', null, this.$t('stores::products-info::message_start_sale')),
                    h('span', { style: 'color: #0560FD' }, res.data.data.successCount),
                    h('span', null, `${$t('stores::products-info::message_store_text')}，`),
                    h('span', null, this.$t('stores::products-info::message_stop_fail')),
                    h('span', { style: 'color: #ff4300' }, res.data.data.failCount),
                    h('span', null, this.$t('stores::products-info::message_store_text')),
                  ]),
                })
              }
              this.handleSellManage({ ...this.currentRow })
            }
          })
          .catch(() => {
            row.saleLoading = false
          })
      })
    },
    dialogTableSelectChange(val) {
      this.dialogTableSelection = val
    },
    handleMessageBox(row, tips, title) {
      return this.$confirm(
        `${tips} <br/ > <div style="width:230px;padding:13px 0;background:#f9f9f9;color:#666;display: inline-block;
    margin-top: 13px;"> ${this.$t('stores::products-info::goods_spu')}：${row.spuId ? row.spuId : row.skuId}</div>`,
        title,
        {
          dangerouslyUseHTMLString: true,
        }
      )
    },
    handleToEdit(row) {
      this.$router.push({
        path: `/products-info/edit/${row.spuId}`,
      })
    },
    handleToDetail(row) {
      // if (row.spuId) {
      //   this.isShowDetailDrawer = true
      //   this.productDetail = { ...row }
      // }
      this.$router.push({
        path: `/products-info/detail/${row.spuId}`,
      })
    },
    // 定价确认
    setPriceConfirm() {
      this.$refs.dynamicValidateForm.validate(async valid => {
        if (valid) {
          this.savePriceLoading = true
          const { data } = await Api.putPriceList({
            spuId: this.setPriceDialogId,
            data: this.currentRow.skus,
          })
          this.savePriceLoading = false
          this.setPriceDialog = false
          if (data.code === this.$code) {
            this.$message.success(this.$t('system::tip::control_success'))
            this.handlePageChange()
          }
        }
      })
    },
    // 批量打标签确认
    batchTagConfirm() {
      if (this.shopTag.length === 0) {
        return this.$message.warning(this.$t('stores::products-info::message_choose_tag'))
      }
      const spuIds = this.tableSelections.map(item => item.spuId)
      Api.batchSetTag({
        tagIds: this.shopTag,
        spuIds,
      }).then(res => {
        if (res.data.code === this.$code) {
          this.$message.success(this.$t('system::tip::control_success'))
          this.batchSetTag = false
          this.handlePageChange()
        }
      })
    },
    releaseTag(item, row) {
      Api.batchRelieveTag({
        tagId: item.id,
        spuId: row.spuId,
      }).then(res => {
        if (res.data.code === this.$code) {
          this.$message.success(this.$t('system::tip::control_success'))
          this.handlePageChange()
        }
      })
    },
    closeDialog() {
      this.handleProduct = {}
      this.isShowSaleDialog = false
    },
  },
}
</script>

<style lang="scss">
.product--table__tag {
  color: #0560fd;
  background-color: rgba(54, 109, 255, 0.1) !important;
  border-color: rgba(54, 109, 255, 0.5);
}
</style>

<style scoped lang="scss">
// /deep/.el-drawer__body {
//   height: 100%;
//   overflow: auto;
// }
// /deep/.el-drawer__header {
//   align-items: center;
//   color: #010517;
//   display: flex;
//   margin-bottom: 0px;
//   padding: 10px 10px 0;
// }
// /deep/.el-table {
//   .el-table-column--selection.table-selection {
//     .cell {
//       opacity: 0;
//     }
//   }
// }
// /deep/.el-table {
//   .el-table__header {
//     .el-table-column--selection.table-selection {
//       .cell {
//         opacity: 1;
//       }
//     }
//   }
// }
.drawer-title {
  font-size: 16px;
  border-bottom: 1px solid #ebeef5;
  padding: 10px 0;
}
.prodinfo--card {
  ::v-deep {
    .z-search {
      margin: 0;
    }
  }
}
.prodinfo--list {
  &__btnWrap {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  &__tips {
    font-family: MicrosoftYaHei;
    height: 40px;
    background: #f9fbff;
    border: 1px solid #bad1ff;
    font-size: 14px;
    color: #010517;
    line-height: 40px;
    padding-left: 16px;
    margin-bottom: 19px;
  }
}
.prodinfo--table {
  /deep/ .el-table tr:hover {
    .common-tag {
      color: #0560fd;
      background-color: rgba(54, 109, 255, 0.1) !important;
      border-color: rgba(54, 109, 255, 0.5);
      .el-tag__close {
        color: #0560fd;
      }
      .el-tag__close:hover {
        color: #fff !important;
      }
    }
    .expand-tag {
      background-color: #fff !important;
    }
  }
  &__imgTd {
    display: flex;
    align-items: center;
    padding: 24px 0;
    .images {
      width: 64px;
      height: 64px;
    }
  }
  /deep/ .el-table td {
    padding: 0;
  }
  .tag-wrap {
    display: flex;
    align-items: center;
    /deep/ .el-icon-close {
      top: 2px !important;
    }
  }
  &__title {
    font-weight: bold;
    color: #010517;
    line-height: 19px;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 180px;
    margin-bottom: 5px;
  }
  &__spu {
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #666666;
    line-height: 16px;
  }
}
.btn-item {
  display: inline-block;
  margin-left: 10px;
}
.common-tag {
  color: #999;
  border-color: #dcdfe6;
  /deep/ .el-tag__close {
    color: #999;
  }
  /deep/ .el-tag__close:hover {
    color: #fff;
  }
}
.product--setPrice {
  &__form {
    /deep/ .el-form-item {
      margin-bottom: 0 !important;
    }
    /deep/ .el-form-item__content {
      line-height: 0;
    }
    /deep/ .el-input-group__prepend {
      color: #333 !important;
    }
  }
}
.holder__color {
  /deep/ .el-input__inner {
    color: #999;
  }
}
.empty-cate {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 180px;
}
</style>
